import EventEmitters from "events"

export default new EventEmitters()
